import moment from 'moment';
import PropTypes from 'prop-types';
import { validateCharacters } from 'lib/Validations';
import RangeAutocomplete from 'components/FilterFields/RangeAutocomplete';

const MAX_YEAR = moment().year();
const MIN_YEAR = 1800;

const getYearOptions = (min) => {
    const yearBuiltOptions = [];
    for (let i = MAX_YEAR; i >= MIN_YEAR; i--) {
        const yearBuiltOpt = {
            label: `${i}`,
            value: `${i}`,
        };

        yearBuiltOptions.push(yearBuiltOpt);
    }

    return [
        { label: min ? 'Min' : 'Max', value: '' },
        ...yearBuiltOptions,
    ];
};

const validateMinAndMaxDate = val => val >= MIN_YEAR && val <= MAX_YEAR;

const validateYear = (val) => {
    const regex = new RegExp(/^\d{4}$/);

    if (!regex.test(val) || !validateMinAndMaxDate(Number(val))) {
        return `* Please input year between ${MIN_YEAR} - ${MAX_YEAR} only`;
    }
};
const validateInput = (value) => {
    return validateCharacters(value)
        || validateYear(value);
};

function YearBuiltFilter(props) {
    return (
        <RangeAutocomplete
            comparableType={props.comparableType}
            attrName={props.attrName}
            label={props.label}
            subLabel="Select an option or manually enter a value"
            minOptions={getYearOptions(true)}
            maxOptions={getYearOptions(false)}
            isDropdown={false}
            formatter={value => value}
            validateInput={validateInput}
            maxInputLength={4}
        />
    );
}

YearBuiltFilter.propTypes = {
    comparableType: PropTypes.string.isRequired,
    attrName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

export default YearBuiltFilter;